import { Row, Col, Image } from "antd";
import { InfoCircleTwoTone } from "@ant-design/icons";

const truncateText = (text, maxWidth) => {
  const span = document.createElement("span");
  span.style.visibility = "hidden";
  span.style.position = "absolute";
  span.style.whiteSpace = "nowrap";
  span.innerText = text;
  document.body.appendChild(span);
  const textWidth = span.offsetWidth;
  document.body.removeChild(span);

  if (textWidth > maxWidth) {
    return (
      text.slice(0, Math.floor((maxWidth / textWidth) * text.length)) + "..."
    );
  }
  return text;
};

const DetailItem = ({ label, value, isImage = false }) => {
  return (
    <Col flex="auto">
      <span className="details-label">{label} :</span>
      {isImage ? (
        <Image src={value} alt={label} width={120} />
      ) : (
        <span className="details-text">{truncateText(value, 150)}</span>
      )}
    </Col>
  );
};

const DetailsBox = ({ details }) => {
  return (
    <Row gutter={[48, 48]} align="middle" wrap>
      {details.map((detail, index) => (
        <DetailItem
          key={index}
          label={detail.label}
          value={detail.value}
          isImage={detail.isImage || false}
        />
      ))}
    </Row>
  );
};

const InfoIcon = () => {
  return <InfoCircleTwoTone className="info-icon" />;
};

const DetailsContainer = ({ details }) => {
  return (
    <div className="details-box">
      <Row gutter={[16, 16]} align="middle" wrap={false}>
        <Col flex="none">
          <InfoIcon />
        </Col>
        <Col flex="auto">
          <DetailsBox details={details} />
        </Col>
      </Row>
    </div>
  );
};

export default DetailsContainer;
